<div class="card-container">
  <div class="flex-coluna1">
    <img class="user-image" src="{{ imageURL }}" />
  </div>
  <div class="flex-coluna2">
    <p class="p-user-name">
      <label class="user-name">{{ fullName }}</label>
    </p>
    <p class="p-user-email">
      {{ email }}
    </p>
  </div>
  <div class="flex-coluna3">
    <input type="image" class="button-remove" src="../../../../assets/icons/icon-lixeira.svg"
      (click)="removeAddedUser()"
    />
  </div>
</div>
